module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "Periodical Evaluation Report( when finishing 20/80/160 classes)",
      "width": "750"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    staticClass: "evaluate"
  }, [_c('el-alert', {
    attrs: {
      "closable": false,
      "title": _vm.title,
      "type": "info",
      "description": "Remember that learning is a continuous process, With your dedication and hard work, you can continue to grow and excel in your language learning journey. Keep up the good work!"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "evaluate"
  }, [_c('h3', [_vm._v("Part one：Student's overal performance in English learning (must include the student's progress in listening, speaking, reading, writing/grammar/vocabulary building，no less than 80 words in total)")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "Enter something..."
    },
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "evaluate"
  }, [_c('h3', [_vm._v("Part two： Learning Suggestions")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("You can list learning suggestions, learning websites etc, and encourage the student to continue English courses.")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Enter something..."
    },
    model: {
      value: (_vm.formData.suggestions),
      callback: function($$v) {
        _vm.$set(_vm.formData, "suggestions", $$v)
      },
      expression: "formData.suggestions"
    }
  }), _vm._v(" "), _c('MultiUpload', {
    staticClass: "title",
    attrs: {
      "num": 1,
      "defaultFileList": this.formData.fileList
    },
    on: {
      "on-file-change": _vm.changeFile
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (!_vm.readonly) ? _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Submit")]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33bae849","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/StudentWriteReviewFinishLevelModal.vue
// module id = 1742
// module chunks = 8